export default "__VITE_ASSET__DN89rtGb__"